import { render, staticRenderFns } from "./BioModelDescription.vue?vue&type=template&id=dfe55600&"
import script from "./BioModelDescription.vue?vue&type=script&lang=js&"
export * from "./BioModelDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BioModelDescription.vue"
export default component.exports